import { useState, useCallback, useContext } from "react";
const isStateFunction = maybeFunction => typeof maybeFunction === "function";

/**
 * Resource hook
 * use a resource to suspend a component based on the resource as state
 * Keeps the memory resource in sync with the state
 * @param {Resource} resource the prepared resource
 * @returns
 */
export const useResource = resource => {
  const [state, setState] = useState(resource.read());
  const setLocalResource = useCallback(newResource => {
    setState(prevState => {
      if (isStateFunction(newResource)) {
        resource.setLocalResource(newResource(prevState));
      } else {
        resource.setLocalResource(newResource);
      }
      return resource.read();
    });
  }, [resource]);
  return [state, setLocalResource];
};
export const useResourceContext = resource => useContext(resource.ReactContext);